/* MCR · perfect-fit photos. When a product photo is shown whole inside a frame of a different shape
   (collection cards in "contain" mode, predictive search, style match, anything with [data-mcr-fit]),
   the empty space is filled with the photo's own studio backdrop, read from the two edges it touches on a
   tiny canvas (handles gradient backdrops). Plain backdrops then look like one seamless picture — no bars, no blur, no cropping.
   Photographic backdrops (model/room shots) fill the frame when at most 20% of background is trimmed;
   anything more keeps the soft blurred fill. Works for images added later (search, AJAX). */
(function () {
  'use strict';
  if (window.__mcrFit) return;
  window.__mcrFit = true;
  var SEL = '.mcr-card__media--contain, [data-mcr-fit]';
  var canvas, ctx;

  // The 24 edge pixels of one side of a 24×24 thumbnail (averaged over 2 rows/columns), or null when the
  // edge is busy (sharp jumps = objects/furniture). Smooth studio gradients pass.
  function side(d, name) {
    var row = [], jumps = 0;
    for (var i = 0; i < 24; i++) {
      var acc = [0, 0, 0];
      for (var j = 0; j < 2; j++) {
        var x = name === 'left' ? j : name === 'right' ? 23 - j : i;
        var y = name === 'top' ? j : name === 'bottom' ? 23 - j : i;
        var k = (y * 24 + x) * 4;
        if (d[k + 3] < 200) return null;
        acc[0] += d[k]; acc[1] += d[k + 1]; acc[2] += d[k + 2];
      }
      row.push([acc[0] / 2, acc[1] / 2, acc[2] / 2]);
      if (i) {
        var p = row[i - 1], q = row[i];
        jumps += Math.abs(p[0] - q[0]) + Math.abs(p[1] - q[1]) + Math.abs(p[2] - q[2]);
      }
    }
    if (jumps / 23 > 48) return null;
    // soften fabric/floor texture so the stretched edge reads as a smooth backdrop, not streaks
    for (var pass = 0; pass < 3; pass++) {
      row = row.map(function (px, n) {
        var s2 = [0, 0, 0], c = 0;
        for (var t = Math.max(0, n - 4); t <= Math.min(23, n + 4); t++) { s2[0] += row[t][0]; s2[1] += row[t][1]; s2[2] += row[t][2]; c++; }
        return [s2[0] / c, s2[1] / c, s2[2] / c];
      });
    }
    return row;
  }

  // Backdrop for the two sides the empty space appears on (top/bottom or left/right): a 24×2 / 2×24
  // image of those edge pixels, stretched behind the photo so the backdrop simply continues.
  function backdrop(img, wide) {
    try {
      if (!canvas) {
        canvas = document.createElement('canvas');
        canvas.width = canvas.height = 24;
        ctx = canvas.getContext('2d', { willReadFrequently: true });
      }
      ctx.clearRect(0, 0, 24, 24);
      ctx.drawImage(img, 0, 0, 24, 24);
      var d = ctx.getImageData(0, 0, 24, 24).data;
      var a = side(d, wide ? 'top' : 'left'), b = side(d, wide ? 'bottom' : 'right');
      if (!a || !b) return null;
      var out = document.createElement('canvas');
      out.width = wide ? 24 : 2; out.height = wide ? 2 : 24;
      var o = out.getContext('2d'), im = o.createImageData(out.width, out.height);
      for (var i = 0; i < 24; i++) {
        [a, b].forEach(function (rowPx, n) {
          var x = wide ? i : n, y = wide ? n : i, k = (y * out.width + x) * 4;
          im.data[k] = rowPx[i][0]; im.data[k + 1] = rowPx[i][1]; im.data[k + 2] = rowPx[i][2]; im.data[k + 3] = 255;
        });
      }
      o.putImageData(im, 0, 0);
      return 'url(' + out.toDataURL() + ')';
    } catch (e) {
      return null;
    }
  }

  function fit(img) {
    var box = img.closest && img.closest(SEL);
    var key = img.currentSrc || img.src;
    if (!box || box.__mcrFit === key) return;
    var first = box.querySelector('img');
    if (first !== img || !img.complete || !img.naturalWidth) return;
    // re-fit when the photo changes (e.g. try-on panes)
    box.__mcrFit = key;
    box.classList.remove('mcr-fit--edge', 'mcr-fit--cover');
    box.style.removeProperty('--mcr-edge');
    var r = box.getBoundingClientRect();
    if (!r.width || !r.height) { box.__mcrFit = null; return; }
    var nat = img.naturalWidth / img.naturalHeight, frame = r.width / r.height;
    var c = backdrop(img, nat > frame);
    if (!c) {
      // photographic backdrop (room, model shot): fill the frame when only a little background is trimmed
      if (1 - Math.min(nat, frame) / Math.max(nat, frame) <= 0.2) box.classList.add('mcr-fit--cover');
      return;
    }
    box.style.setProperty('--mcr-edge', c);
    box.classList.add('mcr-fit--edge');
  }

  document.addEventListener('load', function (e) {
    if (e.target && e.target.tagName === 'IMG') fit(e.target);
  }, true);
  function scan() { document.querySelectorAll(SEL).forEach(function (b) { var i = b.querySelector('img'); if (i) fit(i); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
